<script setup></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 141 96">
    <title>{{ $t('paymentmethods.visa') }}</title>
    <g fill="none" fill-rule="evenodd">
      <path
        fill="#26337A"
        d="M0 6.392A6.396 6.396 0 0 1 6.402 0h128.196C138.134 0 141 2.873 141 6.392v83.216A6.396 6.396 0 0 1 134.598 96H6.402C2.866 96 0 93.127 0 89.608V6.392z"
      />
      <path
        fill="#FFF"
        d="m54.384 63.275 4.92-30.519h7.863l-4.919 30.519h-7.864m36.389-29.77c-1.555-.612-4-1.28-7.047-1.28-7.775 0-13.247 4.141-13.293 10.072-.05 4.386 3.905 6.833 6.887 8.29 3.064 1.495 4.094 2.452 4.082 3.788-.021 2.044-2.446 2.98-4.707 2.98-3.149 0-4.821-.46-7.407-1.6l-1.012-.486-1.1 6.832c1.834.85 5.233 1.588 8.761 1.626 8.263 0 13.632-4.091 13.695-10.424.028-3.479-2.067-6.115-6.605-8.292-2.748-1.415-4.435-2.353-4.416-3.785.002-1.268 1.425-2.626 4.505-2.626 2.572-.042 4.434.552 5.885 1.172l.707.35 1.065-6.617m10.471 18.95c.651-1.754 3.132-8.53 3.132-8.53-.046.08.648-1.768 1.046-2.912l.53 2.632s1.51 7.284 1.82 8.81h-6.528zm9.701-19.668h-6.077c-1.885 0-3.296.54-4.122 2.53L89.068 63.286h8.26s1.347-3.763 1.653-4.589c.9 0 8.926.016 10.072.016.236 1.065.958 4.573.958 4.573h7.298l-6.364-30.499zm-63.158-.005L40.09 53.588l-.825-4.23c-1.434-4.872-5.899-10.154-10.893-12.8l7.042 26.69 8.322-.005L56.12 32.782h-8.333"
      />
      <path
        fill="#EC982D"
        d="M32.945 32.761H20.264l-.105.633c9.868 2.528 16.397 8.63 19.106 15.965L36.51 35.336c-.476-1.934-1.857-2.507-3.565-2.575"
      />
    </g>
  </svg>
</template>
